import ProductsPage from "@pages/products";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/products/")({
	component: ProductsPage,
	staticData: {
		breadcrumbId: "page.products.title",
		breadcrumbTitle: "Products",
	},
});
